import PageLastUpdated from './PageLastUpdated';
import './PageLastUpdated.scss';

export default PageLastUpdated;
